import { inject, Injectable } from "@angular/core";
import { Permission } from "../types/local/lookup.type";
import { HttpClient } from "@angular/common/http";
import { BusinessType, LookupResponse } from "../types/api/registration.types";
import { map, Observable } from "rxjs";
import {
  ProductLookupInternal,
  ProductInternal,
} from "../types/local/product.types";
import { ProductsLookupResponseDto } from "../types/api/api-response-dtos";
import { serverProductsLookupToInternal } from "@shared/utils/helpers";
import { RegistrationService } from "./registration.state";
import { environment } from "@env/environment";

@Injectable({
  providedIn: "root",
})
export class LookupService {
  private _apiUrl = `${environment.API_URL}/lookups`;
  state = inject(RegistrationService);
  httpClient = inject(HttpClient);

  private _getLookup(storageKey: string, nameType: string) {
    const lookups = localStorage.getItem(storageKey);
    if (lookups) {
      const parsedLookups = JSON.parse(lookups) as LookupResponse;
      const nameTypeLookups = parsedLookups.nameTypeLookups;

      return nameTypeLookups.find((lookup) => lookup.nameType === nameType)
        ?.idValues;
    }
    return null;
  }

  numberOfEmployeesLookup() {
    return this._getLookup("merchant_lookups", "NUMBER_OF_EMPLOYEES");
  }

  getPepQuestionFreelancer() {
    return this._getLookup(
      "freelancer_lookups",
      "PEP_QUESTIONNAIRE_FREELANCER_WEB"
    );
  }

  getPaymentInstrumentQuestionFreelancer() {
    return this._getLookup(
      "freelancer_lookups",
      "FREELANCER_KYC_PAYMENT_INSTRUMENTS"
    );
  }
  getCustomerTypesQuestionFreelancer() {
    return this._getLookup(
      "freelancer_lookups",
      "FREELANCER_KYC_CUSTOMER_TYPES"
    );
  }
  getProductServiceTypesQuestionFreelancer() {
    return this._getLookup(
      "freelancer_lookups",
      "FREELANCER_KYC_PRODUCT_SERVICES_TYPES"
    );
  }

  getPepQuestionMerchant() {
    return this._getLookup(
      "merchant_lookups",
      "PEP_QUESTIONNAIRE_BUSINESS_WEB"
    );
  }

  //#region FATCA LOOKUPS
  getFatcaUserTitles() {
    return this._getLookup("freelancer_lookups", "FATCA_USER_TITLE");
  }
  getFatcaNoTINReasons() {
    return this._getLookup("freelancer_lookups", "FATCA_NO_TIN_REASON");
  }
  getFatcaCountries() {
    return this._getLookup("freelancer_lookups", "FATCA_COUNTRY");
  }

  getFatcaResidencyTypes() {
    return this._getLookup("freelancer_lookups", "FATCA_TYPE_OF_RESIDENCY");
  }
  getFatcaTaxResidentQuestion() {
    return this._getLookup("merchant_lookups", "FATCA_TAX_RESIDENT_QUESTION");
  }
  //#endregion

  numberOfLocationsLookup() {
    return this._getLookup("merchant_lookups", "NUMBER_OF_BRANCHES");
  }

  openWalletPurposeLookup() {
    const businessType = this.state.businessType;
    if (businessType() === BusinessType.Freelancer) {
      return this._getLookup(
        "freelancer_lookups",
        "PURPOSE_OF_OPENING_WALLET_INDIVIDUAL"
      );
    } else
      return this._getLookup(
        "merchant_lookups",
        "PURPOSE_OF_OPENING_WALLET_BUSINESS"
      );
  }

  yearlyRangeLookup() {
    return this._getLookup("merchant_lookups", "YEARLY_REVENUE");
  }

  outgoingTransferLookup() {
    return this._getLookup(
      "merchant_lookups",
      "EXPECTED_OUTGOING_MONTHLY_TRANSFERS"
    );
  }

  incomingTransferLookup() {
    return this._getLookup(
      "merchant_lookups",
      "EXPECTED_INCOMING_MONTHLY_TRANSFERS"
    );
  }

  getProducts(): Observable<ProductLookupInternal[]> {
    return this.httpClient
      .get<ProductsLookupResponseDto[]>(`${this._apiUrl}/api/v1/products`)
      .pipe(
        map((response) => {
          const businessType = this.state.businessType();
          return serverProductsLookupToInternal(response, businessType);
        })
      );
  }

  getPermissions() {
    // I want a new clone always
    return permissions.map((permission) => ({ ...permission }));
  }
}

// generate 11 records of Permission type
export const permissions: Array<Permission> = [
  {
    id: 1,
    label: "Pay",
    name: "enablePay",
    isSelected: true,
  },
  {
    id: 2,
    label: "Top Up",
    name: "enableTopup",
    isSelected: true,
  },
  {
    id: 3,
    label: "Transfer",
    name: "enableTransfer",
    isSelected: true,
  },
  {
    id: 5,
    label: "Request",
    name: "enableRequest",
    isSelected: true,
  },
  {
    id: 6,
    label: "Refund",
    name: "enableRefund",
    isSelected: true,
  },
  {
    id: 7,
    label: "Sadad",
    name: "enableSadad",
    isSelected: true,
  },
  {
    id: 8,
    label: "Request Card",
    name: "enableCardIssuance",
    isSelected: true,
  },
  // {
  //   id: 9,
  //   label: "Payroll",
  //   name: "enablePayroll",
  //   isSelected: false,
  // },
  // {
  //   id: 10,
  //   label: "Tamara",
  //   name: "enableTamara",
  //   isSelected: false,
  // },
];

export const getPermissionslookup = () => {
  const lookups = localStorage.getItem("permissions_lookups");
  if (lookups) {
    return JSON.parse(lookups) || [];
  }
  return [];
};
